import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class NotificationCypressAttribute extends CypressAttribute {
  static buttons = {
    CLEAR_NOTIFICATION_BUTTON: 'NotificationCypressAttribute:buttons:CLEAR_NOTIFICATION_BUTTON',
    CLEAR_ALL_NOTIFICATION_BUTTON:
      'NotificationCypressAttribute:buttons:CLEAR_ALL_NOTIFICATION_BUTTON',
    UNCLEAR_NOTIFICATION_BUTTON: 'NotificationCypressAttribute:buttons:UNCLEAR_NOTIFICATION_BUTTON',
    LOAD_MORE_NOTIFICATION_BUTTON:
      'NotificationCypressAttribute:buttons:LOAD_MORE_NOTIFICATION_BUTTON'
  };

  static inputs = {
    COURTHOUSE_NOTIFICATION_CHECKBOX:
      'NotificationCypressAttribute:inputs:COURTHOUSE_NOTIFICATION_CHECKBOX'
  };

  static views = {
    NO_MORE_NOTIFICATIONS_TEXT: 'NotificationCypressAttribute:views:NO_MORE_NOTIFICATIONS_TEXT',
    NOTIFICATION_COUNT: 'NotificationCypressAttribute:views:NOTIFICATION_COUNT',
    NOTIFICATION_MESSAGE: 'NotificationCypressAttribute:views:NOTIFICATION_MESSAGE',
    NOTIFICATION_CARD: 'NotificationCypressAttribute:views:NOTIFICATION_CARD',
    NOTIFICATION_FILTER: 'NotificationCypressAttribute:views:NOTIFICATION_FILTER',
    EMPTY_NOTIFICATIONS_STATE: 'NotificationCypressAttribute:views:EMPTY_NOTIFICATIONS_STATE',
    CLEARED_DATE_FILTER: 'NotificationCypressAttribute:views:CLEARED_DATE_FILTER',
    NOTIFICATION_SETTINGS_COMMENT:
      'NotificationCypressAttribute:views:NOTIFICATION_SETTINGS_COMMENT',
    NOTIFICATION_SETTINGS_INBOX: 'NotificationCypressAttribute:views:NOTIFICATION_SETTINGS_INBOX',
    NOTIFICATION_SETTINGS_TASK: 'NotificationCypressAttribute:views:NOTIFICATION_SETTINGS_TASK',
    NEW_TAB: 'NotificationCypressAttribute:views:NEW_TAB',
    CLEARED_TAB: 'NotificationCypressAttribute:views:CLEARED_TAB',
    SETTINGS_TAB: 'NotificationCypressAttribute:views:SETTINGS_TAB',
    RADIO_LIST: 'NotificationCypressAttribute:views:RADIO_LIST'
  };
}
